import Player from "@vimeo/player"
import { useEffect, useRef } from "react"

type VimeoPlayerProps = {
  id: string
  link: string
  width?: number
  height?: number
} & React.ComponentProps<"div">

export function VimeoPlayer({ className, link, width, height, id, ...props }: VimeoPlayerProps) {
  const playerRef = useRef<Player | null>(null)

  useEffect(() => {
    const options = {
      url: link,
      width: width ?? 640,
      height: height ?? 360,
    }

    try {
      const player = new Player("vimeo-video-" + id, options)

      player.setVolume(0)
    } catch (error) {
      console.error("Failed to initialize Vimeo Player:", error)
    }
  }, [playerRef])

  return <div id={"vimeo-video-" + id} className={"relative bg-black " + className} {...props}></div>
}
